// src/components/LayerPanel/SubTabs.jsx
//
// Nested tab bar, for splitting a single LayerPanel scope into sub-scopes.
//
// Deliberately NOT Tabs.jsx. The outer bar is content-width pills on a filled
// strip; stacking a second row of the same pills directly under it reads as one
// wrapped bar rather than two levels. This is the underline idiom already used
// inside PadRekkoPanel (PadRekkoPanel.jsx:419) — equal-width buttons, teal
// bottom border on the active one — so the two rows are visibly different
// levels of the same hierarchy.
//
// Buttons are equal-width (flex-1) rather than content-width: a sub-bar holds
// two or three items, so there is room, and equal widths keep the underline
// reading as a segmented control instead of a second pill row.

function cx(...c) { return c.filter(Boolean).join(" "); }

export default function SubTabs({ tabs, activeTab, onChange, ariaLabel }) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className="flex-shrink-0 flex border-b border-slate-800/80"
    >
      {tabs.map((tab) => {
        const active = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.id)}
            className={cx(
              "flex-1 px-3 py-2 whitespace-nowrap",
              "text-[10px] font-semibold uppercase tracking-wide",
              // Every button carries the 2px border so selection never shifts
              // the row height — same rule the outer pill bar follows.
              "border-b-2 transition-colors",
              active
                ? "text-accent-action border-accent-action"
                : "text-fg-secondary border-transparent hover:text-gray-300"
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
